import Vue from "vue";
import Vuex from "vuex";
import i18n from "@/common/multilanguage/i18n";

import Login from "./Login";
import ThesaurusFilter from "./ThesaurusFilter";
import ABTest from "./ABTest";

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        /** The current language locale, based on route. */
        currentLanguage: i18n.locale
    },
    mutations: {
        setCurrentLanguage: (state, language) => (state.currentLanguage = language),

        updateLastVisited: function(state, value) {
            state.lastVisited = value;
        }
    },
    getters: {
        currentLanguage: state => state.currentLanguage
    },

    modules: {
        Login: Login.createConfig(),
        ThesaurusFilter: ThesaurusFilter.createConfig(),
        ABTest: ABTest.createConfig()
    }
});



// WEBPACK FOOTER //
// ./src/store/index.js